import AITemplateBuilderModal from './AITemplateBuilderModal';

export default AITemplateBuilderModal;
